import { useCallback } from 'react';
import { useStore } from 'react-redux';
import { selectCanvasZoom } from '@src/features/LogicMapper/logicMapperSlice';
import { RootState } from '@src/app/store'; // Assuming RootState is exported from your store setup

/**
 * Hook that returns a non-reactive, memoized function to get the current canvas zoom level on demand.
 * @returns A function that returns the current canvas zoom level from the Redux store when called.
 */
const useGetCurrentCanvasZoom = () => {
  const store = useStore<RootState>(); // Specify the RootState type for the store

  const getZoomLevel = useCallback(() => {
    const state = store.getState();
    return selectCanvasZoom(state);
  }, [store]); // Dependency on store ensures the function is stable

  return getZoomLevel;
};

export default useGetCurrentCanvasZoom;
